module.exports = __webpack_public_path__ + "img/chemistry.6607ed49.png";